import React from "react";
import { MobileCardItem } from "../../../../";
import { makeStyles } from "@material-ui/styles";
var useStyles = makeStyles(function (theme) {
  return {
    my12: {
      margin: "12px 0"
    },
    mt8: {
      marginTop: "8px"
    }
  };
});

var MobileCampusActivityTabDates = function MobileCampusActivityTabDates(props) {
  // console.log("props", props);
  var classes = useStyles();
  return props.data ? props.data.map(function (activity) {
    return /*#__PURE__*/React.createElement(MobileCardItem, {
      template: "activityDateStaff",
      data: activity,
      classes: classes.my12
    });
  }) : null;
};

export { MobileCampusActivityTabDates };